/* No operation */
export const nop = (..._args: any[]) => {
  // Do nothing
};
